/**
 * 身份认证信息存取
 */
import jwtDecode from 'jwt-decode';

let token;

// eslint-disable-next-line no-unused-vars
const config = { // 参数的说明

    interval: 1, // 间隔天数，间隔为整数

    runNow: false, // 是否立即运行

    time: '23:59:00', // 执行的时间点 时在0~23之间

};

function saveToken(accessToken) {
    localStorage.setItem('token', accessToken);
    console.log('saveToken');
    // eslint-disable-next-line no-use-before-define
    timeoutFunc(config, remove);
}

function getToken() {
    if (!token) {
        token = localStorage.getItem('token');
    }

    return token;
}

function removeToken() {
    token = null;
    console.log('removeToken');
    localStorage.removeItem('token');
}

function getPayload() {
    if (!getToken()) {
        return {};
    }

    let payload = null;
    try {
        payload = jwtDecode(token);
    } catch (e) {
        //
    }

    return payload || {};
}

function checkToken() {
    // const { exp } = getPayload();
    // const userInfo = localStorage.getItem('userInfo');
    //
    // if (!userInfo) {
    //     removeToken();
    //     return false;
    // }
    //
    // const valid = Date.now() < exp * 1000;
    // if (!valid) {
    //     removeToken();
    // }
    //
    // return valid;
    if (getToken()) {
        return true;
    }
    return false;
}

function saveUserInfo(userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
}

function getUserInfo() {
    const userInfo = localStorage.getItem('userInfo');
    if (!userInfo) {
        return {};
    }
    try {
        const result = JSON.parse(userInfo);

        return typeof result === 'object' ? result : {};
    } catch (e) {
        //
    }

    return {};
}

function removeUserInfo() {
    localStorage.removeItem('userInfo');
}

// eslint-disable-next-line no-unused-vars,no-shadow
function timeoutFunc(config, func) {
    // eslint-disable-next-line no-unused-expressions

    console.log('454545');
    config.runNow && func();

    const nowTime = new Date().getTime();

    const timePoints = config.time.split(':').map(i => parseInt(i));

    let recent = new Date().setHours(...timePoints);

    // eslint-disable-next-line no-unused-expressions
    recent >= nowTime || (recent += 24 * 3600000);

    setTimeout(() => {
        func();

        setInterval(func, config.interval * 3600000);
    }, recent - nowTime);
}

function remove() {
    removeUserInfo();
    removeToken();
}

export default {
    saveToken,
    getToken,
    removeToken,
    getPayload,
    checkToken,
    saveUserInfo,
    getUserInfo,
    removeUserInfo,
    timeoutFunc,
    remove,

};